module.exports = __webpack_public_path__ + "static/media/portfolio1.72de3db7.gif";